/**
 * Auto-generated file - DO NOT EDIT
 * This file contains the content hash of the SVG sprite for cache busting
 */
export const ICONS_SPRITE_HASH = '49df32c8ea5a0798930f6c53d7b87e624ac8bd3f7308ea05ad9c12d5fc6951c9';
//# sourceMappingURL=rd-icons-sprite-hash.js.map